import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default config => {
    return async payload => {
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const wholeTokenFromCookie = JSON.parse(
            getCookieByName(sharedCookieKey)
        );

        let spatFromCookie = wholeTokenFromCookie.spat;

        let result = await apiClient(config).apiMethod({
            method: 'GetPoints',
            headers: {
                Authorization: jwtFromCookie,
                'X-Auth-Spat': spatFromCookie,
            },
            args: {
                ...payload,
            },
        });

        return result;
    };
};
